import React, { ReactNode, useState } from 'react'
import Box from '../primitives/Box'
import { Caret } from './Caret'
import {
  MenuItem,
  MenuItemWithLink,
  getMenuItemKey,
  hasLink,
  isSubMenu,
  loginItem,
  menuItems,
} from './MenuItems'

interface Props {
  active: boolean
}

const MobileMenu = ({ active }: Props) => {
  return (
    <Box.ul
      paddingTop={24}
      paddingBottom={0}
      paddingX={0}
      display={active ? 'block' : 'none'}
      css={`
        user-select: none;
        list-style: none;
      `}
    >
      {menuItems.map(item => (
        <RootItem item={item} key={getMenuItemKey(item)} />
      ))}
      <RootItem item={loginItem} key={getMenuItemKey(loginItem)} />
    </Box.ul>
  )
}

const RootItem = ({ item }: { item: MenuItem }) => {
  const [expanded, setExpanded] = useState(false)
  return (
    <Box.li
      fontSize={18}
      fontWeight={700}
      lineHeight="130%"
      paddingX={0}
      margin={0}
      css={`
        :last-child > .root-item-text {
          border-bottom-width: 0;
          margin-bottom: 0;
        }
      `}
    >
      <Box
        className="root-item-text"
        paddingY={16}
        marginTop={0}
        marginBottom={8}
        borderBottomColor="black100"
        borderBottomStyle="solid"
        css={`
          border-bottom-width: 1px;
        `}
      >
        {isSubMenu(item) ? (
          <Box.span
            onClick={isSubMenu(item) ? () => setExpanded(!expanded) : undefined}
            cursor="pointer"
          >
            {item.text}
            <Caret direction={expanded ? 'down' : 'right'} />
          </Box.span>
        ) : (
          <MenuLink href={item.href} text={item.text} />
        )}
      </Box>
      {expanded && isSubMenu(item) ? (
        <Box.ul
          padding={0}
          margin={0}
          css={`
            list-style: none;
          `}
        >
          {item.menuItems.map(child => (
            <SubMenuItem item={child} key={getMenuItemKey(child)} />
          ))}
        </Box.ul>
      ) : null}
    </Box.li>
  )
}

const SubMenuItem = ({ item }: { item: MenuItem }) => {
  return (
    <Box.li
      fontSize={16}
      fontWeight={700}
      lineHeight="130%"
      paddingX={0}
      paddingY={0}
      margin={0}
    >
      <Box paddingY={8}>
        {hasLink(item) ? (
          <MenuLink href={item.href} text={item.text} />
        ) : (
          item.text
        )}
      </Box>
      {isSubMenu(item)
        ? item.menuItems
            .filter(hasLink)
            .map(item => <LeafMenuItem item={item} key={item.href} />)
        : null}
    </Box.li>
  )
}

const LeafMenuItem = ({ item }: { item: MenuItemWithLink }) => {
  return (
    <Box.li
      fontSize={16}
      fontWeight={500}
      lineHeight="130%"
      paddingLeft={12}
      paddingY={8}
      margin={0}
      key={item.href}
    >
      <MenuLink text={item.text} href={item.href} />
    </Box.li>
  )
}

const MenuLink = ({ text, href }: { text: ReactNode; href: string }) => {
  const isExternal = href.startsWith('http')
  return isExternal ? (
    <Box.a href={href} target="_blank">
      {text}
      <Box.span style={{ paddingTop: '5px', paddingLeft: '2px' }}>↗</Box.span>
    </Box.a>
  ) : (
    <Box.Link to={href}>{text}</Box.Link>
  )
}

export default MobileMenu
